import React from 'react';
import 'Pages/MyAccount/MyAccountContainer.css';
import { PageSubTitle } from 'Components/Titles';

export const SectionComponent = ({ subTitle, sectionRight }) => {
  return (
    <div className="membershipSection sectionFlex">
      <div className="flexGrowOne settingsSectionLeft">
        <PageSubTitle text={subTitle} />
      </div>
      <div className="sectionFlex flexDirCol flexGrowTwo settingsSectionRight">
        <div className="flexGrowThree">{sectionRight}</div>
      </div>
    </div>
  );
};
